export default __webpack_public_path__ + "static/impersonator-scam-20b252589c7c4ae96fc5107f079da35d.webp";